import React from "react";
import { IconButton, Stack, Typography } from "@mui/material";
import CloseOutlined from "@ant-design/icons/CloseOutlined";
import ModalContainer from "components/ModalContainer";
import { OutlineButton } from "components/buttons/OutlineButton";
import { SolidButton } from "components/buttons/SolidButton";

const ManualRecordingModal = ({ open, onDiscard, onSave }) => {
  return (
    <ModalContainer display={open} modalWidth="500px">
      <Stack spacing={2.5}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontSize: "18px", fontWeight: "bold", color: "#172664" }}>
            Manual Recording Ended
          </Typography>
          <IconButton onClick={onDiscard} aria-label="Close manual recording dialog" sx={{ p: 0.5 }}>
            <CloseOutlined style={{ fontSize: "18px", color: "rgba(0,0,0,0.45)" }} />
          </IconButton>
        </Stack>
        <Typography sx={{ fontSize: "14px", color: "rgba(0,0,0,0.65)" }}>
          Do you want to save the recorded video?
        </Typography>
        <Stack direction="row" justifyContent="flex-end" spacing={1.5}>
          <OutlineButton width="90px" height="36px" onClick={onDiscard}>
            Discard
          </OutlineButton>
          <SolidButton width="90px" height="36px" onClick={onSave}>
            Save
          </SolidButton>
        </Stack>
      </Stack>
    </ModalContainer>
  );
};

export default ManualRecordingModal;
